var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 14.6665V13.3332C13.3332 12.6259 13.0522 11.9477 12.5521 11.4476C12.052 10.9475 11.3737 10.6665 10.6665 10.6665H5.33317C4.62593 10.6665 3.94765 10.9475 3.44755 11.4476C2.94746 11.9477 2.6665 12.6259 2.6665 13.3332V14.6665",
    stroke: "#545454",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 7.99984C9.47292 7.99984 10.6668 6.80593 10.6668 5.33317C10.6668 3.86041 9.47292 2.6665 8.00016 2.6665C6.5274 2.6665 5.3335 3.86041 5.3335 5.33317C5.3335 6.80593 6.5274 7.99984 8.00016 7.99984Z",
    stroke: "#545454",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon_user.b5958986f24cfcdc1cbdd8c9a784c580.svg";
export { ForwardRef as ReactComponent };